import React from 'react';

const SpinnerContainer: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="w-full flex flex-col justify-center items-center">
    {children}
  </div>
);

export default SpinnerContainer;
